import { render } from "./GestioneAsporto.vue?vue&type=template&id=fb0fe336&scoped=true"
import script from "./GestioneAsporto.vue?vue&type=script&lang=js"
export * from "./GestioneAsporto.vue?vue&type=script&lang=js"

import "./GestioneAsporto.vue?vue&type=style&index=0&id=fb0fe336&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0fe336"]])

export default __exports__